<h1 *ngIf="addMode == 'current'">Add Task to Current</h1>
<h1 *ngIf="addMode == 'backlog'">Backlog</h1>

<div class="inputForm">
  <input #taskInput matInput type="text"
         [(ngModel)]="taskTitle" (ngModelChange)="titleChanged($event)"
         (keydown.enter)="createTask()">
  <button *ngIf="taskTitle" matSuffix mat-icon-button
          aria-label="Clear text" title="Clear text"
          (click)="clearTitle()">
    <mat-icon>close</mat-icon>
  </button>
  <button *ngIf="taskTitle.length >= 3" (click)="createTask()" mat-icon-button
          aria-label="Add task" title="Add task">
    <mat-icon>add_circle</mat-icon>
  </button>
</div>

<div id="taskList" [hidden]="!dataLoaded">
  <div class="scrollable">
    <mat-action-list *ngIf="addMode == 'current'">
      <button mat-list-item (click)="addTaskToCurrent(task)"
              aria-label="Add this task to current list"
              title="Add this task to current list"
              *ngFor="let task of filteredTasks; let i = index">
        {{task.title}}
      </button>
    </mat-action-list>
    <mat-list *ngIf="addMode == 'backlog'">
      <div class="taskRow" *ngFor="let task of filteredTasks; let i = index">
        <a mat-list-item routerLink="/task/{{task.id}}">
          {{task.title}}
        </a>
        <button class="options" mat-icon-button
                aria-label="Task options menu" title="Task options menu"
                [matMenuTriggerFor]="singleTaskMenu"
                [matMenuTriggerData]="{task: task}">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
    </mat-list>
  </div>
</div>

<app-command-bar></app-command-bar>

<div [hidden]="dataLoaded">
  <mat-spinner></mat-spinner>
</div>

<mat-menu #singleTaskMenu="matMenu" yPosition="below">
  <ng-template matMenuContent let-task="task">
    <button mat-menu-item (click)="moveToCurrent(task)">
      Move to Current
    </button>
    <button mat-menu-item (click)="deleteTask(task)">
      Delete
    </button>
    <button mat-menu-item [routerLink]="'/edit-task/' + task.id">
      Edit
    </button>
  </ng-template>
</mat-menu>
